import { IIrisModalConfig } from './modal-config.interface';
import { IrisModalSize } from './modal-size.enum';

/**
 * Builds overlay panel class names for imperative modals and for the future route-modal wrapper.
 * Keep in sync with overlay positioning in IrisModalService.
 */
export function getModalPanelClasses(
  size?: IrisModalSize,
  config?: IIrisModalConfig<unknown>
): string[] {
  const panelClasses = ['iris-overlay-panel', 'iris-overlay-panel-styles'];

  if (size === IrisModalSize.LG) {
    panelClasses.push('iris-overlay-panel-lg');
  } else if (size === IrisModalSize.SM) {
    panelClasses.push('iris-overlay-panel-small');
  }

  if (config?.openAsDrawer) {
    panelClasses.push('iris-overlay-panel-drawer');
    if (config.drawerSide === 'left') {
      panelClasses.push('iris-overlay-panel-drawer-left');
    } else {
      panelClasses.push('iris-overlay-panel-drawer-right');
    }
    if (config.additionalPanelClasses?.length) {
      panelClasses.push(...config.additionalPanelClasses);
    }
    return panelClasses;
  }

  if (config?.additionalPanelClasses?.length) {
    panelClasses.push(...config.additionalPanelClasses);
  }

  return panelClasses;
}
